import React, { Component } from "react";
// import {NotificationManager, NotificationContainer} from 'react-notifications';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";

const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;
const changeFloat = require('../service/excelService.js').changeFloat;
const roundup = require('../service/excelService.js').roundup;
var backend = require('../../config.js').backend;

// Helper function to calculate Sin Admin without floating-point errors
const calculateSinAdmin = (amount, rate) => {
    // Convert to cents to avoid floating-point errors
    const amountInCents = Math.round(amount * 100);
    const ratePercent = Math.round(rate * 10000);
    
    // Calculate in cents
    const sinAdminInCents = Math.round((amountInCents * ratePercent) / 10000);
    
    // Convert back to dollars
    return sinAdminInCents / 100;
};

class EditableMinistryReportDetails extends Component {


    constructor(props) {
        super(props);

        this.state = {
            report: this.props.report,
            donationTotal: this.props.report.donationTotal,
            creditCard: this.props.report.creditCardCharges,
            cheque: this.props.report.chequeCharges,
            additionalRows: this.props.report.additionalRows,
            desigName: this.props.desigName,
            desigId: this.props.desigId,
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            SIN_ADMIN_CHARGE_RATE: 0,
            redirectLogout: false
        }
        //console.log(this.state.report);

    }


    componentDidMount() {

        this.getSinAdminChargesRates()
            .then((result) => {
                // console.log('SIN_ADMIN_CHARGE_RATE', result);
                this.setState({ SIN_ADMIN_CHARGE_RATE: result });

                const { additionalRows } = this.state;
                var reportTotal = this.calcReportTotal(additionalRows);
                this.setState({ reportTotal: reportTotal });

                if (additionalRows) {
                    this.setState({ newAdditionalRows: [...this.state.additionalRows] });
                }
                else {
                    this.setState({ newAdditionalRows: [] });
                }

            })

    }


    calcReportTotal = additionalRows => {

        var { creditCard, cheque } = this.state;
        var { donationTotal } = this.state;
        const { SIN_ADMIN_CHARGE_RATE } = this.state;

        var sinAdmin = calculateSinAdmin(donationTotal, SIN_ADMIN_CHARGE_RATE);
        var reportTotal = roundup(donationTotal - sinAdmin - creditCard - cheque);

        if (additionalRows) {
            var additionalTotal = additionalRows.reduce((totalAmount, additionalRow) => changeFloat(totalAmount) + changeFloat(additionalRow.amount), 0);
            reportTotal = roundup(reportTotal + additionalTotal);
        }

        return reportTotal;

    }

    getSinAdminChargesRates = _ => {

        var { desigId } =  this.state;

        var that = this;

        return new Promise(function (resolve, reject) {

            fetch(backend + 'api/v1/sinadmin/ministry?desigId=' + desigId, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {

                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    } else {
                        resolve(data);
                    }
                })

        });

    }



    renderReportTitle = () => {
        var { startDate } = this.state;
        var { endDate } = this.state;
        startDate = moment(startDate).format('DD-MMM-YYYY');
        endDate = moment(endDate).format('DD-MMM-YYYY');

        return (
            <div className='report-title row'>

                <div className='left'>
                    <div className='logo'>
                        <img id="logo" src="/img/Nav-logo.png" alt="Navlogo" />
                    </div>
                    <h4>{this.state.desigName}</h4>
                </div>

                <div className='right'>
                    <div className='subtitle'>Amounts are in Singapore Dollar (SGD)</div>
                    <div className='subtitle'>Donation dates: {startDate} to {endDate}</div>
                </div>

            </div>
        )
    }


    renderContact = () => {
        const { report } = this.state;
        var contacts = report.contactList;
        return (<div className='contact'>
            {contacts.map((contact, index) => (
                <h4 key={index} className='bold italic'> Payee: {contact.Name} </h4>
            ))}
        </div>
        )
    }

    renderDetailsTable = () => {
        const { report } = this.state;
        var gifts = report.giftList;

        return (
            <table className="table table-borderless table-hover">
                <thead className='border-top border-bottom'>
                    <tr>
                        <th className='donation-date'>Date</th>
                        <th className='donation-amount'>Amount</th>
                        <th className='donor-name'>Donor Name and DonorID Number</th>
                    </tr>
                </thead>
                <tbody>
                    {gifts.map(this.renderGiftRow)}
                    {this.renderDonationTotal(gifts)}
                    {this.renderAdditionalRows()}
                    {this.renderSummary()}
                </tbody>

            </table>

        )

    }

    renderDonationTotal = (gifts) => {

        var { creditCard, cheque } = this.state;
        var { donationTotal } = this.state;
        const { SIN_ADMIN_CHARGE_RATE } = this.state;

        var sinAdmin = calculateSinAdmin(donationTotal, SIN_ADMIN_CHARGE_RATE);
        console.log('sinAdmin', sinAdmin);
        const display_sinAdmin = changeFloat(100 * SIN_ADMIN_CHARGE_RATE);

        return (sinAdmin !== 0) ? (<React.Fragment>
            <tr>
                <td></td>
                <td className='donation-amount bold border-top'>${numberWithCommas_display(donationTotal)}</td>
                <td className='bold'>{gifts.length} Donations</td>
            </tr>
            <tr>
                <td>{display_sinAdmin}% Sin Admin Charges</td>
                <td className='donation-amount'>(${numberWithCommas_display(sinAdmin)})</td>
                <td></td>
            </tr>
            <tr>
                <td>Credit Card Charge</td>
                <td className='donation-amount'>(${numberWithCommas_display(creditCard)})</td>
                <td></td>
            </tr>
            <tr>
                <td>Cheque Charge</td>
                <td className='donation-amount'>(${numberWithCommas_display(cheque)})</td>
                <td></td>
            </tr>
        </React.Fragment>
        ) : (<React.Fragment>
            <tr>
                <td></td>
                <td className='donation-amount bold border-top'>${numberWithCommas_display(donationTotal)}</td>
                <td className='bold'>{gifts.length} Donations</td>
            </tr>
            <tr>
                <td>Credit Card Charge</td>
                <td className='donation-amount'>(${numberWithCommas_display(creditCard)})</td>
                <td></td>
            </tr>
            <tr>
                <td>Cheque Charge</td>
                <td className='donation-amount'>(${numberWithCommas_display(cheque)})</td>
                <td></td>
            </tr>
        </React.Fragment>
        )

    }

    renderGiftRow = (gift, index) => {

        const ReceivedDate = moment(gift.ReceivedDate).format('DD-MMM-YYYY');
        // Conditional logic for display name and ID
        const donorNameDisplay = gift.DonorName.toLowerCase().includes('anonymous') ? 'Anonymous' : gift.DonorName;
        const donorIDDisplay = donorNameDisplay === 'Anonymous' ? '' : gift.DonorID;
        return (
            <tr key={index}>
                <td>{ReceivedDate}</td>
                <td className='donation-amount'>${numberWithCommas_display(gift.TenderedAmount)}</td>
                <td>{donorNameDisplay}{donorIDDisplay && `(${donorIDDisplay})`}</td>
            </tr>
        )

    }

    deleteFromAdditionalRowList = index => {

        var { newAdditionalRows } = this.state;

        newAdditionalRows.splice(index, 1);

        this.setState({ newAdditionalRows: newAdditionalRows }, function () {
            var reportTotal = this.calcReportTotal(newAdditionalRows);
            this.setState({ reportTotal: reportTotal })
        });


    }

    handleContentChange = (index, event) => {

        var { newAdditionalRows } = this.state;
        var row = newAdditionalRows[index];
        row.content = event.target.value;

        newAdditionalRows[index] = row;
        this.setState({ newAdditionalRows: newAdditionalRows });

    }

    handleAmountChange = (index, event) => {

        var { newAdditionalRows } = this.state;
        var row = newAdditionalRows[index];
        row.amount = event.target.value;
        newAdditionalRows[index] = row;

        this.setState({ newAdditionalRows: newAdditionalRows }, function () {
            var reportTotal = this.calcReportTotal(newAdditionalRows);
            this.setState({ reportTotal: reportTotal })
        });

    }

    handleRemarkChange = (index, event) => {

        var { newAdditionalRows } = this.state;
        var row = newAdditionalRows[index];
        row.remark = event.target.value;

        newAdditionalRows[index] = row;
        this.setState({ newAdditionalRows: newAdditionalRows });

    }


    createRow = () => {

        var { newAdditionalRows } = this.state;
        var newRow = {
            content: '',
            amount: '',
            remark: ''
        }

        newAdditionalRows.push(newRow);
        this.setState({ newAdditionalRows: newAdditionalRows })

    }

    renderNewRowButton = () => {
        return (
            <tr>
                <td><button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => this.createRow()}>
                    Add item
                </button></td>
                <td></td>
                <td></td>
            </tr>
        )
    }

    handleSave = () => {

        this.props.addToAdditionalRows(this.state.desigId, this.state.newAdditionalRows)
        this.props.closePopup();

    }

    handleCancel = () => {
        this.props.closePopup();
    }

    renderAdditionalRow = (row, index) => {

        return (

            <tr key={index} className='additionalRow'>

                <td>
                    <input
                        value={row.content}
                        type="text"
                        name="content"
                        placeholder="Item name"
                        onChange={(e) => this.handleContentChange(index, e)}
                    ></input>
                </td>
                <td className='donation-amount'>
                    <input
                        value={row.amount}
                        type="text"
                        name="amount"
                        placeholder="Amount"
                        onChange={(e) => this.handleAmountChange(index, e)}
                    ></input>
                </td>
                <td>
                    <input
                        value={row.remark}
                        type="text"
                        placeholder="Remarks"
                        onChange={(e) => this.handleRemarkChange(index, e)}
                    ></input>
                    <DeleteIcon onClick={() => this.deleteFromAdditionalRowList(index)} />
                </td>

            </tr>)
    }

    renderAdditionalRows = () => {

        var { newAdditionalRows } = this.state;

        // render addition rows
        if (newAdditionalRows && newAdditionalRows.length) {
            return (<React.Fragment>
                {newAdditionalRows.map(this.renderAdditionalRow)}
                {this.renderNewRowButton()}
            </React.Fragment>)
        }
        else {
            return (
                this.renderNewRowButton()
            )
        }


    }


    renderSummary = () => {
        // render addition rows
        const { reportTotal } = this.state

        var content = (
            <tr>
                <td className='bold'>Total for this report: </td>
                <td className='donation-amount bold border-top'>{numberWithCommas_display(reportTotal)}</td>
                <td></td>
            </tr>)
        // add new row
        return (content)
    }


    renderReport = () => {

        return (<div>
            {this.renderReportTitle()}
            {this.renderContact()}
            {this.renderDetailsTable()}
        </div>)
    }



    render() {
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let { report } = this.state
        var report_details = this.renderReport(report);

        let content = (
            <div className='edit-ministry-donations-report'>
                <div className='popup'>

                    <span className="close" onClick={this.props.closePopup}>×</span>

                    <div className='popup_inner'>

                        <div className="ministry-report-details">
                            {report_details}
                            <div className="ministry-report-buttons">
                                <button
                                    onClick={this.handleSave}
                                    className="btn btn-primary">
                                    Save
                                </button>

                                <button
                                    onClick={this.handleCancel}
                                    className="btn btn-primary">
                                    Cancel
                                </button>

                            </div>

                        </div>


                    </div>

                </div>
            </div>)

        return content

    }

}


export default EditableMinistryReportDetails;
